module.exports = __webpack_public_path__ + "img/duration.d209d181.svg";